import { TLBaseShape, RecordProps, T, HTMLContainer, BaseBoxShapeUtil } from "@tldraw/tldraw";

type FoldLineShape = TLBaseShape<
  "foldLine",
  {
    w: number;
    h: number;
    // Fold positions in px, measured from the left (axis x) or top (axis y) edge.
    folds: number[];
    axis: "x" | "y";
  }
>;

const FOLD_STROKE = "#3b82f6";
const FOLD_DASH = "8 6";

// Locked guide drawn over the canvas at each panel boundary of a folded format.
export class FoldLineUtil extends BaseBoxShapeUtil<FoldLineShape> {
  static type = "foldLine" as const;
  static props: RecordProps<FoldLineShape> = {
    w: T.number,
    h: T.number,
    folds: T.arrayOf(T.number),
    axis: T.literalEnum("x", "y"),
  };

  isAspectRatioLocked(_shape: FoldLineShape): boolean {
    return true;
  }

  canResize(): boolean {
    return false;
  }

  getDefaultProps(): FoldLineShape["props"] {
    return { w: 0, h: 0, folds: [], axis: "x" };
  }

  component(shape: FoldLineShape) {
    const { w, h, folds, axis } = shape.props;

    return (
      <HTMLContainer id={shape.id} style={{ pointerEvents: "none" }}>
        <svg width={w} height={h} style={{ overflow: "visible", pointerEvents: "none" }}>
          {folds.map((position) =>
            axis === "x" ? (
              <line
                key={position}
                x1={position}
                y1={0}
                x2={position}
                y2={h}
                stroke={FOLD_STROKE}
                strokeWidth={1}
                strokeDasharray={FOLD_DASH}
              />
            ) : (
              <line
                key={position}
                x1={0}
                y1={position}
                x2={w}
                y2={position}
                stroke={FOLD_STROKE}
                strokeWidth={1}
                strokeDasharray={FOLD_DASH}
              />
            )
          )}
        </svg>
      </HTMLContainer>
    );
  }

  indicator(_shape: FoldLineShape) {
    return null;
  }
}
